// extracted by mini-css-extract-plugin
export default {"link":"AuthLink-module__link__dmzAw","variant":"AuthLink-module__variant__Xif-q","filled":"AuthLink-module__filled__4Edox","outlined":"AuthLink-module__outlined__UVXmQ"};